export default import.meta.ROLLDOWN_FILE_URL_$e_rW06YrDsCDSlzhACLCg